module.exports = __webpack_public_path__ + "static/pattern-washed_dark.9c40cd38.png";